<template>
  <v-container fluid>
    <!-- ヘッダー部 -->
    <v-row>
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center" color="blue-grey" dark>
          保健室受付(検索して受付)
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" justify="left">
        <v-card class="mx-auto text-left" color="white">
          課程・部・科・学年・受付日を指定し、検索した後に登録を行ってください。(※学級は任意指定となります)
        </v-card>
      </v-col>
    </v-row>
    <!-- 検索条件部 start -->
    <v-row dense>
      <v-col cols="12" justify="center">
        <v-card class="mx-auto text-center" color="white">
          <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-row dense>
              <v-col cols="2" justify="center">
                <ValidationProvider
                  name="課程"
                  rules="required"
                  v-slot="{ errors }"
                  :skipIfEmpty="false"
                >
                  <v-select
                    label="課程"
                    :items="kateiMst"
                    @change="changeKBK"
                    item-text="name"
                    item-value="code"
                    v-model="selectedKatei"
                    :error-messages="errors[0]"
                    outlined
                    dense
                    hide-details="auto"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="1" justify="center">
                <ValidationProvider
                  name="部"
                  rules="required"
                  v-slot="{ errors }"
                  :skipIfEmpty="false"
                >
                  <v-select
                    label="部"
                    :items="buMst"
                    @change="changeKBK"
                    item-text="name"
                    item-value="code"
                    v-model="selectedBu"
                    :error-messages="errors[0]"
                    outlined
                    dense
                    hide-details="auto"
                    ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="2" justify="center">
                <ValidationProvider
                  name="科"
                  rules="required"
                  v-slot="{ errors }"
                  :skipIfEmpty="false"
                >
                  <v-select
                    label="科"
                    :items="kaMst"
                    @change="changeKBK"
                    item-text="name"
                    item-value="code"
                    v-model="selectedKa"
                    :error-messages="errors[0]"
                    outlined
                    dense
                    hide-details="auto"
                    ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="1" justify="center">
                <ValidationProvider
                  name="学年"
                  rules="required"
                  v-slot="{ errors }"
                  :skipIfEmpty="false"
                >
                <v-select
                  label="学年"
                  :items="gakunenMst"
                  item-text="name"
                  item-value="code"
                  v-model="selectedGakunen"
                  :error-messages="errors[0]"
                  outlined
                  dense
                  hide-details="auto"
                  ></v-select>
                </ValidationProvider>
              </v-col>
              <v-col cols="2" justify="center">
                <v-select
                  label="学級"
                  :items="gakkyuMst"
                  item-text="name"
                  item-value="code"
                  v-model="selectedGakkyu"
                  outlined
                  dense
                  clearable
                  multiple
                  chips
                  deletable-chips
                  hide-details="auto"
                  ></v-select>
              </v-col>
              <v-col cols="2" justify="center">
                <ValidationProvider name="受付日" rules="required" v-slot="{ errors }">
                  <v-text-field
                    v-model="receptionDate"
                    label="受付日"
                    placeholder=""
                    type="date"
                    :error-messages="errors[0]"
                    outlined
                    dense
                    hide-details="auto"
                    ></v-text-field>
                </ValidationProvider>
              </v-col>  
              <v-col cols="1" justify="center">
                <v-btn color="accent" class="ml-auto mt-0 black--text" @click="onSearch" :disabled="invalid">検索</v-btn>
              </v-col>
          </v-row>
          </ValidationObserver>
        </v-card> 
      </v-col>
    </v-row>
    
    <v-row dense>
      <v-col cols="6" justify="center">
        <v-card class="mx-auto text-center">
          <!-- 検索用のテキスト入力 -->
          <v-text-field
            v-model="search"
            label="氏名ｶﾅ検索"
            placeholder="氏名ｶﾅ検索"
            outlined
            dense
            hide-details="auto"
            background-color="white"
          ></v-text-field>
        </v-card>
      </v-col>
      <v-col cols="2" justify="center">
      </v-col>  
      <v-col cols="2" justify="center">
        <div align="left">
          <v-btn color="accent" class="black--text" @click="toHealthRoomReception()" width="90%">バーコード受付</v-btn>
        </div>
      </v-col>
      <v-col cols="2">
        <div align="left">
          <v-btn color="accent" class="black--text" @click="toHealthRoomRecodeEdit()" width="90%">傷病の記録</v-btn>
        </div>
      </v-col>
    </v-row>
    <!-- 検索条件部 end -->
    <!-- 明細 -->
    <v-row dense>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="userList"
          :items-per-page="-1"
          :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
          :loading="isListLoding" loading-text="読込中"
          dense
        >
          <template #[`item.userNmKana`]="{ item }">
            {{ item.userNm }}({{ item.userNmKana }})
          </template>

          <!-- 入室ボタン 退室ボタン -->
          <template #[`item.checkOutFlg`]="{ item }">
            <v-btn large v-if="item.checkOutFlg == true" class="red--text" @click="checkIn(item)">
              <v-icon x-large left>
                mdi-location-enter
              </v-icon>
              <span>入室</span>
            </v-btn>
            <v-btn large v-if="item.checkOutFlg == false" class="blue--text" @click="checkOut(item)">
              <span>退室</span>
              <v-icon x-large right>
                mdi-location-exit
              </v-icon>
            </v-btn>
          </template>
      </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
  
<script>
import { httpsCallable, getFunctions } from "firebase/functions";
import Enumerable from "linq";
export default {
  data() {
    return {
      // 検索条件用
      // KBK制御
      kateiMst: [],
      buMst: [],
      kaMst: [],
      gakunenMst: [],
      gakunenMstBase: [],
      gakkyuMst: [],
      gakkyuMstBase: [],
      selectedKatei: "01",
      selectedBu: "",
      selectedKa: "",
      selectedGakunen: "",
      selectedGakkyu: [],
      receptionDate: "",

      search: "",

      // 明細用
      headers: [
        { text: "学級", value: "gakkyu", align: "start"},
        { text: "出席番号", value: "syussekiNo", align: "start"},
        { text: "生徒氏名(ｶﾅ)", value: "userNmKana", filter: this.userNmKanaFilter},
        { text: "入室時刻", value: "checkInTime" },
        { text: "退室時刻", value: "checkOutTime" },
        { text: "", value: "checkOutFlg" },
      ],
      userList: [],
      isListLoding: false,
    };
  },
  // 初期処理
  async created() {
    this.defaultDateSet();
    // KBKGCの取得
    const functions = getFunctions(this.$firebase);
    functions.region = "asia-northeast1";
    const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
    await schoolAidHomeLogined({funcName:"commonGetKBKG"}).then((ret) => {
      this.kateiMst = ret.data.kateiMst;
      this.buMst = ret.data.buMst;
      this.kaMst = ret.data.kaMst;
      this.gakunenMstBase = ret.data.gakunenMst;
      this.gakkyuMstBase = ret.data.gakkyuMst;
    });
  },
  methods: {
    // =============================== 初期処理用 start ===============================
    // 検索条件日付の初期設定１
    defaultDateSet() {
      this.receptionDate = this.formatDate(new Date());
    },
    // 検索条件日付の初期設定２
    formatDate(dt){
      var y = dt.getFullYear();
      var m = ('00' + (dt.getMonth()+1)).slice(-2);
      var d = ('00' + dt.getDate()).slice(-2);
      return (y + '-' + m + '-' + d);
    },
    // =============================== 初期処理用 end ===============================
    // =============================== ヘッダー部用処理 start ===============================
    // 課程・部・科設定後のセレクトボックス変更
    changeKBK() {
      if(this.selectedKatei
       && this.selectedBu
       && this.selectedKa){
        // 学年マスタをKBKでフィルタ
        this.gakunenMst = Enumerable.from(this.gakunenMstBase).where(i => 
        i.code.substring(0, 8) == (
          this.selectedKatei
          + "-"
          + this.selectedBu
          + "-"
          + this.selectedKa
          )).toArray();
        this.selectedGakunen = "";
        // 学級マスタをKBKでフィルタ
        this.gakkyuMst = Enumerable.from(this.gakkyuMstBase).where(i => 
        i.code.substring(0, 8) == (
          this.selectedKatei
          + "-"
          + this.selectedBu
          + "-"
          + this.selectedKa
          )).toArray();
        this.selectedGakkyu = [];
      }
    },
    // 氏名カナフィルタ
    userNmKanaFilter(value) {
      if (value.includes(this.search)) {
        return true;
      } else {
        return false;
      }
    },
    // 保健室受付画面へ
    toHealthRoomReception() {
      this.$router.push({
        name: "HealthRoomReception",
      });
    },
    // 傷病記録の登録
    toHealthRoomRecodeEdit() {
      this.$router.push({
        name: "HealthRoomRecodeEdit",
      });
    },

    // =============================== ヘッダー部用処理 start ===============================
    // 検索処理
    async onSearch() {
      const data = {
        funcName: "searchHealthRoomReception",
        kateiCd: this.selectedKatei,
        buCd: this.selectedBu,
        kaCd: this.selectedKa,
        gakunenCd: this.selectedGakunen,
        gakkyuCd: this.selectedGakkyu,
        receptionDate: this.receptionDate,
      };
      this.userList = [];
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      this.isListLoding = true;
      await schoolAidHomeLogined(data).then((ret) => {
        this.userList = ret.data;
        this.isListLoding = false;
      });
    },
    // =======================================================================================
    // 入室処理
    async checkIn(item) {
      const data = {
        funcName: "checkInHealthRoomReceptionRegist",
        studentId: item.studentId,
        receptionDate: item.yyyymmdd,
      };
      let studentId = item.studentId;

      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(data).then((ret) => {
        for(let row of this.userList){
          if(studentId == row.studentId){
            row.checkInTime = ret.data.procTime;
            row.checkOutTime = "";
            row.historyId = ret.data.historyId;
            row.checkOutFlg = false;
          }
        }
      });
    },
    // 退室処理
    async checkOut(item) {
      const data = {
        funcName: "checkOutHealthRoomReceptionRegist",
        studentId: item.studentId,
        receptionDate: item.yyyymmdd,
        historyId: item.historyId,
      };

      let studentId = item.studentId;

      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(data).then((ret) => {
        for(let row of this.userList){
          if(studentId == row.studentId){
            row.checkOutTime = ret.data;
            row.historyId = "";
            row.checkOutFlg = true;
          }
        }
      });
    },
  },
};
</script>